let id = 1

export const useUniqueId = () => id++
